//TODO need refactor router
//public router doesnot need to create login by token logic
export const noLoginByTokenLogicRoutes = [
  '/change-password',
  '/edit-password',
  '/confirm-terms',
  '/register',
  '/confirm-email',
  '/confirm-phone',
  '/confirm-phone-code',
  '/email-confirmation',
  '/forgot-password',
  '/reset-password',
  '/two-steps-verification',
  '/two-steps-code',
  '/privacy-policy',
  '/terms',
];
